import * as UnitWeight from 'types/Ingredient/Detail/UnitWeight';

export type Type = UnitWeight.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type): {
	[key: string]: number;
} {
	const output: {
		[key: string]: number;
	} = {};
	for (const i of obj) {
		output[i.id] = i.weight;
	}
	return output;
}
